/**
 * @function addPluralSuffixS 
 * @param {number} count
 * @returns {string} 's' if count > 1, '' if count <= 1
 * @description returns plural 's' suffix if count > 1
 * @example addPluralSuffixS(1) => ''
 * @example addPluralSuffixS(null) => ''
 * @example addPluralSuffixS(2) => 's'

 */

export const addPluralSuffixS = (count: any) => {
  if (typeof count === 'number' && count > 1) {
    return 's';
  }
  return '';
};
